import { render, staticRenderFns } from "./HomeContactUs.vue?vue&type=template&id=318fbdde&scoped=true&"
import script from "./HomeContactUs.vue?vue&type=script&lang=ts&"
export * from "./HomeContactUs.vue?vue&type=script&lang=ts&"
import style0 from "./HomeContactUs.vue?vue&type=style&index=0&id=318fbdde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318fbdde",
  null
  
)

export default component.exports